export default __webpack_public_path__ + "static/media/bg-nav-stay-active.4ea4c83b.jpg";